import { render, staticRenderFns } from "./ColoredGoalWidget.vue?vue&type=template&id=2bf1cf32&scoped=true&"
import script from "./ColoredGoalWidget.vue?vue&type=script&lang=js&"
export * from "./ColoredGoalWidget.vue?vue&type=script&lang=js&"
import style0 from "./ColoredGoalWidget.vue?vue&type=style&index=0&id=2bf1cf32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf1cf32",
  null
  
)

export default component.exports